import React from 'react'
import Marker from '../Marker'
import SendIcon from '../SendIcon'

function AddressInfo() {
  return (
    <div className='address-info'>
        <Marker/>
        <div className='address-text'>
        Vadistanbul Bulvar . 2A/28 . Sarıyer . İstanbul . Turkiye
        </div>
        <a className='send-badge' href='mailto:mrk@ramaaz.com'>
            <SendIcon/> <span>Send To Us</span>
        </a>
    </div> 
  )
}

export default AddressInfo